export default __webpack_public_path__ + "b54724f54d4dd3f6796e3c4cc422f998.ttf";